import React from 'react';
export var LockIcon = function LockIcon(_ref) {
  var fill = _ref.fill;
  return /*#__PURE__*/React.createElement("svg", {
    fill: fill,
    height: "12",
    viewBox: "0 0 24 24",
    width: "12",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3c2 0 3.7 1 3.7 3v3H8.3V6c0-2 1.7-3 3.7-3Zm5.5 6V6c0-3-2.5-5-5.5-5S6.5 3 6.5 6v3c-.8.2-1.5 1-1.5 2v6c0 1.1.8 2 1.8 2h10.4c1 0 1.8-.9 1.8-2v-6c0-1-.7-1.8-1.5-2Z"
  }));
};